export async function getUserDetails(email, authToken) {
    const response = await fetch(`/get-user-details/${email}`, { 
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
    });

    return response;
}

export async function updateUserMarketingDetails(email, authToken, professionalRole, referralSource) {
    const response = await fetch(`/update-user-marketing-details/${email}`, { 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
            professionalRole,
            referralSource
        })
    });

    return response.json();

}